import { createContext, useEffect } from 'react';
import { emptyTracker, isEmptyTracker } from 'reporting-data/tsTypes/usageTrackerTypes';
import { getUsageTracker } from 'reporting-ui-components/monitoring/usageTracker';
import useEnablementCloneTracker from '../hooks/useCloneTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnablementTrackingContext = /*#__PURE__*/createContext({
  appUsageTracker: emptyTracker,
  enablementUsageTracker: emptyTracker
});
export function EnablementTrackingProvider({
  appUsageTracker,
  trackingAssetType,
  trackingApplicationName,
  trackingScreenName,
  trackingSubscreenName,
  children
}) {
  // TODO: Migrate to new events tracking system and remove tracker from context altogether as this is an anti-pattern
  // https://git.hubteam.com/HubSpot/reporting-enablement/issues/2265
  const primaryTracker = getUsageTracker();
  const reportingTracker = isEmptyTracker(primaryTracker) ? appUsageTracker : primaryTracker;
  const enablementUsageTracker = useEnablementCloneTracker(appUsageTracker);
  useEffect(() => {
    reportingTracker === null || reportingTracker === void 0 || reportingTracker.setProperties({
      assetType: trackingAssetType,
      applicationName: trackingApplicationName,
      whereScreen: trackingScreenName,
      subscreen: trackingSubscreenName
    });
    if (!isEmptyTracker(enablementUsageTracker)) {
      enablementUsageTracker === null || enablementUsageTracker === void 0 || enablementUsageTracker.setProperties({
        assetType: trackingAssetType,
        applicationName: trackingApplicationName,
        whereScreen: trackingScreenName,
        subscreen: trackingSubscreenName
      });
    }
  }, [trackingAssetType, trackingApplicationName, trackingScreenName, trackingSubscreenName, reportingTracker, enablementUsageTracker]);
  return /*#__PURE__*/_jsx(EnablementTrackingContext.Provider, {
    value: {
      appUsageTracker: reportingTracker || emptyTracker,
      enablementUsageTracker,
      trackingAssetType,
      trackingApplicationName,
      trackingScreenName,
      trackingSubscreenName
    },
    children: children
  });
}
export function WithEnablementTrackingProvider(Component) {
  return function WithEnablementTrackingContext(props) {
    const {
      appUsageTracker,
      trackingAssetType = 'report',
      trackingApplicationName,
      trackingScreenName,
      trackingSubscreenName
    } = props;
    return /*#__PURE__*/_jsx(EnablementTrackingProvider, {
      appUsageTracker: appUsageTracker,
      trackingApplicationName: trackingApplicationName,
      trackingAssetType: trackingAssetType,
      trackingScreenName: trackingScreenName,
      trackingSubscreenName: trackingSubscreenName,
      children: /*#__PURE__*/_jsx(Component, Object.assign({}, props))
    });
  };
}